import { KStadiumInstance } from '../../instance';
import { HexlantAllownaceRes, HexlantRes } from './types';

const SUB_URL = `/bridge`;

export const withdraw = (
  htlcContractAddress: string,
  hashlock: string,
  fromPreImage: string,
) =>
  KStadiumInstance.post<HexlantRes>(`${SUB_URL}/withdraw`, {
    hashlock,
    htlcContractAddress,
    preImage: fromPreImage,
  }).then((res) => res.data);

export const newContract = (
  amount: string,
  chainId: string,
  hashlock: string,
  receiver: string,
  timelock: string,
  htlcContractAddress: string,
) =>
  KStadiumInstance.post<HexlantRes>(`${SUB_URL}/newContract`, {
    amount,
    chainId,
    hashlock,
    htlcContractAddress,
    receiver,
    timelock,
  }).then((res) => res.data);

export const newContractToken = (
  amount: string,
  chainId: string,
  hashlock: string,
  receiver: string,
  timelock: string,
  htlcTokenContractAddress: string,
  tokenContractAddress: string,
) =>
  KStadiumInstance.post<HexlantRes>(`${SUB_URL}/newContract/token`, {
    amount,
    chainId,
    hashlock,
    htlcTokenContractAddress,
    receiver,
    timelock,
    tokenContractAddress,
  }).then((res) => res.data);

export const refund = (hashlock: string, htlcContractAddress: string) =>
  KStadiumInstance.post<HexlantRes>(`${SUB_URL}/refund`, {
    hashlock,
    htlcContractAddress,
  }).then((res) => res.data);

export const allowance = (contract: string, spender: string) =>
  KStadiumInstance.post<HexlantAllownaceRes>(`${SUB_URL}/allowance`, {
    contract,
    spender,
  }).then((res) => res.data);

export const approve = (amount: string, contract: string, spender: string) =>
  KStadiumInstance.post<HexlantRes>(`${SUB_URL}/approve`, {
    amount,
    contract,
    spender,
  }).then((res) => res.data);
